<app-common-table [params]="getTableParams()"></app-common-table>